import { type ReactElement, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Card } from "@garden/ui";
import {
  registerSellerPortalI18n,
  SELLER_PORTAL_NS,
} from "@/features/seller-portal/i18n";

export interface SettingsSectionCardProps {
  title: string;
  testid: string;
  children: ReactNode;
  onSave?: () => void;
  saving?: boolean;
  disabled?: boolean;
}

export function SettingsSectionCard({
  title,
  testid,
  children,
  onSave,
  saving = false,
  disabled = false,
}: SettingsSectionCardProps): ReactElement {
  registerSellerPortalI18n();
  const { t } = useTranslation(SELLER_PORTAL_NS);

  return (
    <div data-testid={testid}>
      <Card padding={16}>
        <h2 className="mb-3 text-sm font-semibold text-foreground">{title}</h2>
        <div className="flex flex-col gap-3">{children}</div>
        {onSave != null ? (
          <div className="mt-4 flex justify-end">
            <button
              type="button"
              disabled={disabled || saving}
              onClick={onSave}
              data-testid={`${testid}-save`}
              className="rounded-[var(--g-radius)] bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground disabled:opacity-50"
            >
              {t("settings.save")}
            </button>
          </div>
        ) : null}
      </Card>
    </div>
  );
}
